import programs from '../../programs/index';

function betaFilter(program, profile) {
  if (!program.beta) {
    return true;
  }
  return !!profile.tester;
}

function regionFilter(program, profile) {
  if (!Array.isArray(program.limitToRegions)) {
    return true;
  }
  const profileRegion = [profile.country, profile.stateOrProvince, profile.cityOrMunicipality].join('/');
  return program.limitToRegions
    .some(regionFilter => profileRegion.indexOf(regionFilter) === 0);
}

function featuredOnlyFilter(program/*, profile*/) {
  return (!program.featuredOnly);
}

function featuredFilter(program, featuredPrograms) {
  return featuredPrograms.indexOf(program.id) >= 0;
}

export function getAvailableProgramsForProfile(profile) {
  if (profile.staff) {
    return programs.programList;
  }
  return programs.programList
    .filter(x => betaFilter(x, profile))
    .filter(x => regionFilter(x, profile))
    .filter(x => featuredOnlyFilter(x, profile));
}

export function getFeaturedProgramsForProfile(profile) {
  const featuredProgramIds = getFeaturedProgramIds();
  return programs.programList
    .filter(x => betaFilter(x, profile))
    .filter(x => regionFilter(x, profile))
    .filter(x => featuredFilter(x, featuredProgramIds));
}

export function getProgramsLookup() {
  return programs.programLookup;
}

export function hasFeaturedPrograms() {
  return !!tryGetCookieValue("featuredPrograms");
}

export function getFeaturedProgramIds() {
  const value = tryGetCookieValue("featuredPrograms");
  return (typeof value === 'string' ? value.split(',') : [])
}

class ProgramHelper {
  constructor (program, featuredLanguage) {
    this._program = program;
    this._featuredLanguage = featuredLanguage;
  }
  get found() {
    return !!this._program;
  }
  get programId() {
    return (this._program && this._program.id) || '';
  }
  get featuredLanguage() {
    if (this._program && this._program.languages && this._program.languages.includes(this._featuredLanguage)) {
      return this._featuredLanguage;
    } else {
      return 'en';
    }
  }
}

export function getFeaturedProgramHelper(programId) {
  const featuredProgramId = programId || getFeaturedProgramIds()[0];
  const featuredLanguage = tryGetCookieValue("featuredLanguage");
  return new ProgramHelper(programs.programLookup[featuredProgramId], featuredLanguage);
}



// WEBPACK FOOTER //
// ./src/services/programs.js